// src/components/Toast.js
import React from "react";
import { useToast } from "../context/ToastContext";  // Import the useToast hook

const Toast = () => {
    const { toastMessage, toastType } = useToast();  // Get message and type from context

    if (!toastMessage) return null;

    const backgroundColor = toastType === "success" ? "bg-green-500" : "bg-red-500";

    return (
        <div
            className={`fixed top-4 left-1/2 transform -translate-x-1/2 p-4 rounded-lg text-white ${backgroundColor} 
                w-4/5 sm:max-w-xs md:max-w-sm lg:max-w-md text-center`}
            style={{ zIndex: 9999 }}
        >
            <div className="flex items-center justify-center">
                <p className="text-sm sm:text-base md:text-lg">{toastMessage}</p>
            </div>
        </div>
    );
};

export default Toast;
